import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DATE_TIME_FORMAT } from 'src/constants/Generals';

const formatPeriod = declaration => {
  if (declaration.periodType === 'monthly') {
    return `${String(declaration.periodMonth).padStart(2, '0')}/${declaration.periodYear}`;
  }
  return `Q${declaration.periodQuarter}/${declaration.periodYear}`;
};

const formatExportedAt = declaration => {
  if (!declaration.exportedAt) {
    return '-';
  }
  return moment(declaration.exportedAt).format(DATE_TIME_FORMAT);
};

const IncomeTaxDeclarationTableRow = ({ declaration, onClick, mode, isChecked, onCheckboxChange }) => (
  <tr className="m-table-row table-hover" onClick={mode === 'SHOW' ? onClick : undefined} style={{ cursor: mode === 'SHOW' ? 'pointer' : 'default' }}>
    {mode === 'EDIT' && (
      <td className="m-table-cell--center" role="presentation" onClick={e => e.stopPropagation()}>
        <input type="checkbox" checked={isChecked} onChange={onCheckboxChange} />
      </td>
    )}
    <td>{declaration.declarationName || '-'}</td>
    <td>{declaration.office || '-'}</td>
    <td>{declaration.formCode || '-'}</td>
    <td>{formatPeriod(declaration)}</td>
    <td>{formatExportedAt(declaration)}</td>
  </tr>
);

IncomeTaxDeclarationTableRow.propTypes = {
  declaration: PropTypes.shape({
    id: PropTypes.number,
    declarationName: PropTypes.string,
    office: PropTypes.string,
    formCode: PropTypes.string,
    periodType: PropTypes.string,
    periodMonth: PropTypes.number,
    periodYear: PropTypes.number,
    periodQuarter: PropTypes.number,
    exportedAt: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  mode: PropTypes.string,
  isChecked: PropTypes.bool,
  onCheckboxChange: PropTypes.func
};

IncomeTaxDeclarationTableRow.defaultProps = {
  mode: 'SHOW',
  isChecked: false,
  onCheckboxChange: () => {}
};

export default IncomeTaxDeclarationTableRow;
